import classes from "./Report.module.css";
import {Table} from "react-bootstrap";
import { ReactComponent as POLL_COUNT } from "./images/CountIconPoll.svg";
import { ReactComponent as ATTENDANCE_COUNT } from "./images/CountIconAttendance.svg";
import { ReactComponent as QUESTION_COUNT } from "./images/CountIconQuestion.svg";
import { ReactComponent as RESPONSE_COUNT } from "./images/CountIconResponse.svg";
import { ReactComponent as PARTICIPANT_COUNT } from "./images/CountIconParticipant.svg";
import { ReactComponent as NAN_COURSE } from "./images/NanCourseIcon.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    REPORT_INSTITUTION_NAN_COURSE_TABLE_HEADERS
} from "../../utils/constants";
import {useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TabStandalone({data={}, reportStartDate, reportEndDate, isUserWise=false }) {
    const { t } = useTranslation();
    const {
        pollCount=0,
        attendanceCount=0,
        questionCount=0,
        responseCount=0,
        participantCount=0
    } = data;

    let history = useHistory();


    const onClickFullReport = () => {
        document.getElementsByTagName("main")[0].scrollTo(0, 0);
        history.push({
            pathname: isUserWise ? "/report/user-standalone" : "/report/standalone",
            state: { reportStartDate, reportEndDate}
        });
    }


    return (
        <>
            {(pollCount + attendanceCount) > 0 &&
                <div className={classes.viewNanCourseReportContainer}>
                    <div className={classes.viewNanCourseReportIconContainer}>
                        <NAN_COURSE/>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: 15}}>
                        <div style={{display: "flex", gap: 10, alignItems: "center"}}>
                            <span className={classes.regularLabel} style={{fontWeight: "800"}}>{t("report.institutionViewNanCourseTitle")}</span>
                            <span className={classes.viewNanCourseReportCountContainer}>
                                {(pollCount + attendanceCount).toLocaleString()} {t("poll.totalActivities")}
                            </span>
                        </div>
                        <span className={classes.regularLabel}>{t("report.institutionViewNanCourseDesc")}</span>
                    </div>
                    <div style={{flex: 1}}/>
                    <YuJaButton onClick={onClickFullReport} tabIndex={0} wrapperStyle={{whiteSpace: "nowrap"}}>{t("report.institutionViewNanCourseButton")}</YuJaButton>
                </div>
            }

            <div className={classes.tableWrapper}>
                <Table hover>
                    <thead>
                        <tr>
                            <th width={200}>
                                <span className={classes.firstCell}>{t(REPORT_INSTITUTION_NAN_COURSE_TABLE_HEADERS.METRIC_NAME.labelKey)}</span>
                            </th>
                            <th width={50}>{t(REPORT_INSTITUTION_NAN_COURSE_TABLE_HEADERS.COUNT.labelKey)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span className={classes.firstCell}>
                                    <POLL_COUNT/> {t("poll.totalGradedPolls")}
                                </span>
                            </td>
                            <td>{pollCount}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className={classes.firstCell}>
                                   <ATTENDANCE_COUNT/> {t("poll.totalAttendances")}
                                </span>
                            </td>
                            <td>{attendanceCount}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className={classes.firstCell}>
                                    <QUESTION_COUNT/> {t("report.totalQuestionsText")}
                                </span>
                            </td>
                            <td >{questionCount}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className={classes.firstCell}>
                                    <RESPONSE_COUNT/> {t("report.responseMetricTitle")}
                                </span>
                            </td>
                            <td>{responseCount}</td>
                        </tr>
                        <tr>
                            <td>
                                <span className={classes.firstCell}>
                                    <PARTICIPANT_COUNT/> {t("poll.participantsPlatformText")}
                                </span>
                            </td>
                            <td>{participantCount}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </>
    );
}